import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
export var HowToFindBrandsThatHaveInsiderFreeShippingIA = function HowToFindBrandsThatHaveInsiderFreeShippingIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize)];
    }
  };
};
var HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING = function HOW_TO_FIND_BRANDS_WITH_INSIDER_FREE_SHIPPING(strictLocalize) {
  return getSettingSelfServeRetailerTaxonomy() ? strictLocalize({
    id: "PYlSze",
    defaultMessage: [{
      "type": 0,
      "value": "Encontre marcas com envio gratuito com Insider"
    }]
  }) : strictLocalize({
    id: "B8cwFF",
    defaultMessage: [{
      "type": 0,
      "value": "Como encontro marcas com envio gratuito com Insider?"
    }]
  });
};
var TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING = function TO_FIND_BRANDS_AND_PRODUCTS_OFFERING_INSIDER_FREE_SHIPPING(strictLocalize) {
  return strictLocalize({
    id: "HHlKBq",
    defaultMessage: [{
      "type": 0,
      "value": "Para encontrar marcas e produtos que oferecem envio gratuito com Insider, preste atenção ao símbolo de chave azul \"Envio gratuito com Insider\" enquanto navega no site. Quando vir produtos ou marcas com este símbolo, terá automaticamente envio gratuito com Insider quando finalizar a compra nessa marca. Além disso, pode personalizar a sua experiência de compras para ver apenas produtos que têm envio gratuito com Insider. Para tal, encontre e clique no filtro Insider na parte superior da categoria que estiver a ver."
    }]
  });
};